<template>
    <view-card :title="title" v-if="value">
        <v-row v-if="isAuthorized" slot="title-actions">
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <view-description-modify v-model="expert" @input="sync" />
            </v-col>
        </v-row>
        <data-list :dataList="dataList" />
    </view-card>
</template>

<script>
import DataList from "./data-list.vue";
import ViewCard from "./view-card.vue";
import ViewBrochures from "./view-brochures.vue";
import ItemAreaBadges from "./item-area-badges.vue";
import ViewDescriptionModify from "./view-description-modify/view-description-modify.vue";
import { USER_TYPES } from "@/assets/data/CONSTANTS";

export default {
    components: {
        DataList,
        ViewCard,
        ViewBrochures,
        ItemAreaBadges,
        ViewDescriptionModify,
    },
    props: {
        value: Object,
    },
    computed: {
        isSupporter() {
            return this.value?.type == USER_TYPES.INDIVIDUAL;
        },
        isOrganization() {
            return this.value?.type == USER_TYPES.ORGANIZATION;
        },
        isAuthorized() {
            return this.value?._id == this.$store.state.payload._user;
        },
        title() {
            if (this.isOrganization) return "제품 및 기술 정보";
            if (this.isSupporter) return "보유기술 정보";
            return "";
        },
        dataList() {
            return this.value?.expertDescriptions || [];
        },
    },
    data() {
        return {
            expert: {},
        };
    },
    methods: {
        init() {
            this.expert = { ...(this.value || {}) };
        },
        sync() {
            this.$emit("input", this.expert);
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>

<style></style>
